import * as msal from '@azure/msal-browser'
import router from '../router'

const loginRequest = {
  extraQueryParameters: { domain_hint: 'cobbvantress.com' },
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

const config = {
  auth: {
    clientId: '0b7b9e5e-72ee-4ec9-808b-b78bfae9762e', //iag app id
    authority: 'https://login.microsoftonline.com/da45342c-ce89-44fe-82c9-2c8502e05791/', // cobb tenant id
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

const msalApp = new msal.PublicClientApplication(config);

export default {
  async signIn() {
    const response = await msalApp.loginPopup(loginRequest);
    localStorage.setItem('iag-loginHint', response.account.username);
    return response;
  },
  async ssoSilent() {
    let response = null;
    try {
      const loginHint = localStorage.getItem('iag-loginHint');
      if (loginHint == null) {
        if (router.currentRoute.path !== '/signin') {
          router.push({ path: '/signin' });
        }
        return null;
      }
      loginRequest.loginHint = loginHint;

      response = await msalApp.ssoSilent(loginRequest);

      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' });
      }
    } catch (error) {
      localStorage.removeItem('iag-loginHint');
      if (router.currentRoute.path !== '/signin') {
        router.push({ path: '/signin' });
      }
    }
    return response;
  },
  async acquireToken(tokenRequest) {
    const loginHint = localStorage.getItem('iag-loginHint');
    const account = msalApp.getAccountByUsername(loginHint);

    if (account == null) {
      return null;
    }

    const accessTokenRequest = {
      scopes: tokenRequest.scopes,
      account: account,
      forceRefresh: tokenRequest.forceRefresh,
      redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI
    };

    let response = null;
    try {
      response = await msalApp.acquireTokenSilent(accessTokenRequest);
    } catch (error) {
      response = await msalApp.acquireTokenPopup(accessTokenRequest);
    }
    //* Just in case check, probably never triggers
    if (!response.accessToken) {
      throw new Error('### accessToken not found in response');
    }
    return response.accessToken;
  },
  async getOptions(tokenRequest, method, body, isJsonContentType) {
    const accessToken = await this.acquireToken(tokenRequest);
    const options = { 
      method: method
    };

    if (body) {
      options.body = body;
    }

    if (isJsonContentType) {
      options.headers = { 
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${accessToken}` 
      };
    } else {
      options.headers = { 
        'Authorization': `Bearer ${accessToken}` 
      };
    }

    return options;
  },
  signOut() {
    msalApp.logoutPopup();
  }
}